import { Container } from 'react-bootstrap';
import IconifyIcon from '../wrappers/IconifyIcon';
import { currentYear, developedBy, developedByLink } from '../../context/constants';

const Footer = () => (
  <footer className="footer">
    <Container fluid className="px-3 px-lg-4">
      <p className="footer-credit mb-0">
        <span className="footer-credit__line">
          <span className="footer-credit__sanduk">© {currentYear} Sanduk</span>
          <span className="footer-credit__dot" aria-hidden>
            ·
          </span>
          <span className="footer-credit__made">Made with</span>
          <IconifyIcon
            icon="iconamoon:heart-duotone"
            className="footer-credit__heart text-danger"
            aria-hidden
          />
          <span className="footer-credit__by">by</span>
          <a
            href={developedByLink}
            className="footer-credit__link"
            target="_blank"
            rel="noreferrer"
          >
            {developedBy}
          </a>
        </span>
      </p>
    </Container>
  </footer>
);

export default Footer;
